export default "__VITE_ASSET__498aaa9d__"